export enum EApiUrl {
    unitySignIn = 'go-rewards/api/unanimity/signin',
    unitySignUp = 'go-rewards/api/unanimity/signup',
    unityOtp = 'go-rewards/api/unanimity/otp',
    unityUserSummary = 'go-rewards/api/unanimity/summary',
    unityDocuments = 'go-rewards/api/unanimity/consent-document',
    authStatus = 'go-webshop/api/v1/auth-status',
    logout = 'go-webshop/api/v1/logout',
    requestSmsCode = 'go-webshop/api/v1/auth/request-sms-code',
    verifySmsCode = 'go-webshop/api/v1/auth/verify-sms-code',
    chooseProfile = 'go-webshop/api/v1/choose-profile',
    profile = 'go-webshop/api/v1/profile',
    userBalance = 'go-webshop/api/v1/profile/balance',
    wdollarPackages = 'go-webshop/api/v1/shop/offers',
    publicWdollarPackages = 'go-webshop/api/v1/public/shop/offers',
    createPaysafeOrder = 'go-webshop/api/v1/shop/create-order',
    completePaysafeOrder = 'go-webshop/api/v1/shop/complete-order',
    redeemOptions = 'go-webshop/api/v1/freeplay/redemption-options',
    redeem = 'go-webshop/api/v1/freeplay/redeem',
    purchaseHistory = 'go-webshop/api/v1/profile/history',
    creditCard = 'go-webshop/api/v1/shop/saved-cards',
    creditCardDelete = 'go-webshop/api/v1/shop/delete-saved-card',
    createCustomerToken = 'go-webshop/api/v1/shop/create-single-use-customer-token',
    order = 'go-wdollar-portal/api/orders',
}
